/** "+10%" from 1000 bps; "0%" from 0. */
export function pct(bps: number, withSign = false): string {
  const v = bps / 100;
  const s = Number.isInteger(v) ? String(v) : v.toFixed(v < 10 ? 2 : 1).replace(/\.?0+$/, "");
  return `${withSign && bps > 0 ? "+" : ""}${s}%`;
}

/** 15000 bps → "1.5×" */
export function multiplier(totalBps: number): string {
  const v = totalBps / 10_000;
  return `${Number.isInteger(v) ? v.toFixed(0) : v.toFixed(2).replace(/0$/, "")}×`;
}

/** Group thousands, keep up to `maxFrac` decimals, trim trailing zeros. */
export function gxr(amount: string | number, maxFrac = 2): string {
  const n = typeof amount === "number" ? amount : Number(amount);
  if (!Number.isFinite(n)) return String(amount);
  const fixed = n.toLocaleString("en-US", {
    maximumFractionDigits: maxFrac,
    minimumFractionDigits: 0,
  });
  return fixed;
}

/** Compact: 1234567 → "1.23M" */
export function compact(amount: string | number): string {
  const n = typeof amount === "number" ? amount : Number(amount);
  if (!Number.isFinite(n)) return String(amount);
  return n.toLocaleString("en-US", { notation: "compact", maximumFractionDigits: 2 });
}

/** "hh:mm:ss" until `target`; "00:00:00" once passed. */
export function countdown(target: Date | string | number, now: Date | number = Date.now()): string {
  const t = typeof target === "number" ? target : new Date(target).getTime();
  const n = typeof now === "number" ? now : now.getTime();
  const total = Math.max(0, Math.floor((t - n) / 1000));
  const d = Math.floor(total / 86_400);
  const h = Math.floor((total % 86_400) / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const hms = [h, m, s].map((x) => String(x).padStart(2, "0")).join(":");
  return d > 0 ? `${d}d ${hms}` : hms;
}

/** Whole days between now and target, never negative. */
export function daysUntil(target: Date | string, now: Date | number = Date.now()): number {
  const t = new Date(target).getTime();
  const n = typeof now === "number" ? now : now.getTime();
  return Math.max(0, Math.ceil((t - n) / 86_400_000));
}

export function shortDate(iso: string): string {
  return new Date(iso).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    timeZone: "UTC",
  });
}

export function shortAddress(raw: string): string {
  return raw.length <= 14 ? raw : `${raw.slice(0, 6)}…${raw.slice(-6)}`;
}
